import React from 'react';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import _ from 'lodash';
export const SocialProfilesBasicInfoComponent = ({ handleFormAttachmentItemChange, selectedSocialProfiles, socialProfileType }: any) => (
    <>
        {_.map(
                  selectedSocialProfiles,
                  (selectedSocialProfile: any, index: any) => (
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <InputContainer
                        label="SocialProfile Type"
                        labelField="Text"
                        list={socialProfileType}
                        onValueChange={(event: any) => {
                            handleFormAttachmentItemChange({
                                value: event.target.value,
                                field: 'SocialProfileTypeId',
                                idx: index
                              });
                            } }
                        optionName='Choose SocialProfile Type'
                        type="select"
                        value={selectedSocialProfile?.SocialProfileTypeId}
                        valueField="Value"
                    />

                    <InputContainer
                        label="Name"
                        name="Name"
                        onValueChange={(event: any) => {
                            handleFormAttachmentItemChange({
                                value: event.target.value,
                                field: 'Name',
                                idx: index
                              });
                            } }
                       
                        type="text"
                        value={selectedSocialProfile?.Name}
                    />

                    <InputContainer
                        label="SocialProfile Url"
                        name="SocialProfileUrl"
                        onValueChange={(event: any) => {
                            handleFormAttachmentItemChange({
                                value: event.target.value,
                                field: 'SocialProfileUrl',
                                idx: index
                              });
                            } }

                        type="text"
                        value={selectedSocialProfile?.SocialProfileUrl}
                    />

                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            handleFormAttachmentItemChange({
                                value: event.target.value,
                                field: 'Description',
                                idx: index
                              });
                            } }
                        type="text"
                        value={selectedSocialProfile?.Description}
                    />
                </div>
            }
            expandedPanel="basicInfo"
            headerTitle="Basic Info"
        />
    )
)}
    </>
)
export default SocialProfilesBasicInfoComponent;
